import * as Algorithms from './StatAlgorithms'

const statAlgorithmDeclarations = {}


statAlgorithmDeclarations["Baseball"] = {
  "Hitting": {
    "Batting Average": Algorithms.battingAverage,
    "At Bats": Algorithms.sum,
    "Runs": Algorithms.sum,
    "Hits": Algorithms.sum,
    "Doubles": Algorithms.sum,
    "Triples": Algorithms.sum,
    "Home Runs": Algorithms.sum,
    "Runs Batted In": Algorithms.sum,
    "Total Bases": Algorithms.sum,
    "Slugging Percentage": Algorithms.sluggingPercentage,
    "Base on Balls": Algorithms.sum,
    "Strike Outs": Algorithms.sum,
    "Stolen Base Attempts": Algorithms.sum,
    "Stolen Bases": Algorithms.sum,
  },
  "Fielding": {
    "Putouts": Algorithms.sum,
    "Assists": Algorithms.sum,
    "Errors": Algorithms.sum,
  },
  "Pitching": {
    "Wins": Algorithms.sum,
    "Losses": Algorithms.sum,
    "Saves": Algorithms.sum,
    "Innings Pitched": Algorithms.inningsPitched,
    "Earned Run Average": Algorithms.ERA,
    "Strike Outs": Algorithms.sum,
    "Base on Balls": Algorithms.sum,
    "Hits Allowed": Algorithms.sum,
    "Doubles Allowed": Algorithms.sum,
    "Triples Allowed": Algorithms.sum,
    "Home Runs Allowed": Algorithms.sum,
  }
}


statAlgorithmDeclarations["Softball"] = {
  "Hitting": {
    "Batting Average": Algorithms.battingAverage,
    "At Bats": Algorithms.sum,
    "Runs": Algorithms.sum,
    "Hits": Algorithms.sum,
    "Doubles": Algorithms.sum,
    "Triples": Algorithms.sum,
    "Home Runs": Algorithms.sum,
    "Runs Batted In": Algorithms.sum,
    "Total Bases": Algorithms.sum,
    "Slugging Percentage": Algorithms.sluggingPercentage,
    "Base on Balls": Algorithms.sum,
    "Strike Outs": Algorithms.sum,
    "Stolen Base Attempts": Algorithms.sum,
    "Stolen Bases": Algorithms.sum,
  },
  "Fielding": {
    "Putouts": Algorithms.sum,
    "Assists": Algorithms.sum,
    "Errors": Algorithms.sum,
  },
  "Pitching": {
    "Wins": Algorithms.sum,
    "Losses": Algorithms.sum,
    "Saves": Algorithms.sum,
    "Innings Pitched": Algorithms.inningsPitched,
    "Earned Run Average": Algorithms.ERA,
    "Strike Outs": Algorithms.sum,
    "Base on Balls": Algorithms.sum,
    "Hits Allowed": Algorithms.sum,
    "Doubles Allowed": Algorithms.sum,
    "Triples Allowed": Algorithms.sum,
    "Home Runs Allowed": Algorithms.sum,
  }
}


statAlgorithmDeclarations["Basketball"] = {
  "Basketball": {
    "Total Points": Algorithms.sum,
    "Field Goals Attempted / Field Goals Made": Algorithms.ratio,
    "3-point Field Goals Attempted / 3-point Field Goals Made": Algorithms.ratio,
    "Free throws attempted / Free throws made": Algorithms.ratio,
    "Offensive Rebounds": Algorithms.sum,
    "Defensive Rebounds": Algorithms.sum,
    "Total Rebounds": Algorithms.sum,
    "Assists": Algorithms.sum,
    "Blocks": Algorithms.sum,
    "Steals": Algorithms.sum,
    "Turnovers": Algorithms.sum,
  }
}


statAlgorithmDeclarations["Cross Country"] = {
  "Cross Country": {
    "Distance": Algorithms.minMax,
    "Place": Algorithms.averageToOneDecimal,
    "Time": Algorithms.averageTime
  }
}


statAlgorithmDeclarations["Football"] = {
  "Rushing": {
    "Rushing Attempts": Algorithms.sum,
    "Yards Gained": Algorithms.sum,
    "Yards Lost": Algorithms.sum,
    "Net Rushing Yards": Algorithms.sum,
    "Average Yards per Carry": Algorithms.yardsPerCarry,
    "Rushing Touchowns": Algorithms.sum,
    "Longest Rush": Algorithms.maximum,
  },
  "Receiving": {
    "Number of Receptions": Algorithms.sum,
    "Receiving Yards": Algorithms.sum,
    "Average Yards per Reception": Algorithms.yardsPerReceptions,
    "Receiving Touchdowns": Algorithms.sum,
    "Longest Reception": Algorithms.maximum,
  },
  "QB Passing": {
    "Quarterback Rating": Algorithms.averageToOneDecimal,
    "Passing Attempts": Algorithms.sum,
    "Completions": Algorithms.sum,
    "Completion Percentage": Algorithms.completionPercentage,
    "Interceptions": Algorithms.sum,
    "Passing Yards": Algorithms.sum,
    "Passing Touchdowns": Algorithms.sum,
    "Longest Completion": Algorithms.maximum,
  },
  "QB Rushing": {
    "Rushing Attempts": Algorithms.sum,
    "Yards Gained": Algorithms.sum,
    "Yards Lost": Algorithms.sum,
    "Net Rushing Yards": Algorithms.sum,
    "Average Yards per Carry": Algorithms.qbYardsPerCarry,
    "Rushing Touchowns": Algorithms.sum,
    "Longest Rush": Algorithms.maximum,
  },
  "Defense": {
    "Solo Tackles": Algorithms.sum,
    "Assisted Tackles": Algorithms.sum,
    "Total Tackles": Algorithms.sum,
    "Tackles for Loss Yardage": Algorithms.sum,
    "Sacks": Algorithms.sum,
    "Sack Yardage": Algorithms.sum,
    "Interceptions": Algorithms.sum,
    "Pass Breakups": Algorithms.sum,
    "Quarterback Hurries": Algorithms.sum,
    "Fumbles Recovered": Algorithms.sum,
    "Forced Fumbles": Algorithms.sum,
    "Blocked Kicks": Algorithms.sum,
    "Safeties": Algorithms.sum,
  },
  "Punt": {
    "Number of Punts": Algorithms.sum,
    "Punting Yardage": Algorithms.sum,
    "Average Yard per Punt": Algorithms.yardsPerPunt,
    "Longest Punt": Algorithms.maximum,
    "Touchbacks": Algorithms.sum,
    "Fair Catches": Algorithms.sum,
    "Punts Inside the 20": Algorithms.sum,
    "Punts Inside the 10": Algorithms.sum,
    "Punts Longer than 50 Yards": Algorithms.sum,
  },
  "Field Goals": {
    "Field Goals Attempted": Algorithms.sum,
    "Field Goals Made": Algorithms.sum,
    "Distances": Algorithms.fieldGoalDistances,
  },
  "Points after Touchdown": {
    "PATs Attempted": Algorithms.sum,
    "PATs Made": Algorithms.sum,
    "Points": Algorithms.sum,
  },
  "Kickoffs": {
    "Number of Kickoffs": Algorithms.sum,
    "Kickoff Yardage": Algorithms.sum,
    "Average Yards per Kickoff": Algorithms.yardsPerKickoff,
    "Touchbacks": Algorithms.sum,
    "Kickoffs Out of Bounds": Algorithms.sum,
  },
  "Punt Returns": {
    "Number of Punt Returns": Algorithms.sum,
    "Punt Return Yardage": Algorithms.sum,
    "Average Yards per Punt Return": Algorithms.yardsPerPuntReturn,
    "Punt Return Touchdowns": Algorithms.sum,
    "Longest Punt Return": Algorithms.maximum,
  },
  "Kickoff Returns": {
    "Number of Kickoff Returns": Algorithms.sum,
    "Kickoff Return Yardage": Algorithms.sum,
    "Average Yards per Kickoff Return": Algorithms.yardsPerKickoffReturn,
    "Kickoff Return Touchdowns": Algorithms.sum,
    "Longest Kickoff Return": Algorithms.maximum,
  }
}


statAlgorithmDeclarations["Golf"] = {
  "Golf": {
    "Number of Holes": Algorithms.sum,
    "Score": Algorithms.averageToTwoDecimals,
    "Finish": Algorithms.averageToOneDecimal,
    "Number of Pars": Algorithms.sum,
    "Number of Eagles": Algorithms.sum,
    "Number of Holes in One": Algorithms.sum,
    "Number of Bogeys": Algorithms.sum,
    "Number of Double Bogeys": Algorithms.sum,
    "Number of Triple Bogeys": Algorithms.sum,
  }
}

statAlgorithmDeclarations["Hockey"] = {
  "Skater": {
    "Goals": Algorithms.sum,
    "Assists": Algorithms.sum,
    "Points": Algorithms.sum,
    "Shorthanded Points": Algorithms.sum,
  },
  "Goaltending": {
    "Goals Against": Algorithms.sum,
    "Saves": Algorithms.sum,
    "Wins": Algorithms.sum,
    "Losses": Algorithms.sum,
    "Ties": Algorithms.sum,
    "Shut Outs": Algorithms.sum,
  },
  "Penalties": {
    "Number of Penalties": Algorithms.sum,
    "Penalty Minutes": Algorithms.totalTime,
    "Number of Minor Penalties": Algorithms.sum,
    "Number of Major Penalties": Algorithms.sum,
  }
}


statAlgorithmDeclarations["Ice Hockey"] = {
  "Skater": {
    "Goals": Algorithms.sum,
    "Assists": Algorithms.sum,
    "Points": Algorithms.sum,
    "Shorthanded Points": Algorithms.sum,
  },
  "Goaltending": {
    "Goals Against": Algorithms.sum,
    "Saves": Algorithms.sum,
    "Wins": Algorithms.sum,
    "Losses": Algorithms.sum,
    "Ties": Algorithms.sum,
    "Shut Outs": Algorithms.sum,
  },
  "Penalties": {
    "Number of Penalties": Algorithms.sum,
    "Penalty Minutes": Algorithms.totalTime,
    "Number of Minor Penalties": Algorithms.sum,
    "Number of Major Penalties": Algorithms.sum,
  }
}


statAlgorithmDeclarations["Lacrosse"] = {
  "Offense": {
    "Goals": Algorithms.sum,
    "Assists": Algorithms.sum,
    "Points": Algorithms.sum,
    "Face Offs Attempted": Algorithms.sum,
    "Face Offs Won": Algorithms.sum,
  },
  "Goaltending": {
    "Goals Against": Algorithms.sum,
    "Shots on Goal": Algorithms.sum,
    "Saves": Algorithms.sum,
    "Wins": Algorithms.sum,
    "Losses": Algorithms.sum,
    "Shutouts": Algorithms.sum,
  }
}


statAlgorithmDeclarations["Soccer"] = {
  "Offense": {
    "Goals": Algorithms.sum,
    "Assists": Algorithms.sum,
    "Points": Algorithms.sum,
    "Shots": Algorithms.sum,
    "Shots on Goal": Algorithms.sum,
    "Penalty Goals / Penalty Attempts": Algorithms.ratio,
  },
  "Goalkeeping": {
    "Goals Allowed": Algorithms.sum,
    "Saves": Algorithms.sum,
    "Wins": Algorithms.sum,
    "Losses": Algorithms.sum,
    "Ties": Algorithms.sum,
    "Shutouts": Algorithms.sum,
  }
}


statAlgorithmDeclarations["Track & Field"] = {
  "100 Meter": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "200 Meter": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "400 Meter": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "800 Meter": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "1600 Meter": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "3200 Meter": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "110 Meter Hurdles": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "300 Meter Hurdles": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "4 x 100 Meter Relay": {
    "Split Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "4 x 200 Meter Relay": {
    "Split Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "4 x 400 Meter Relay": {
    "Split Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "4 x 800 Meter Relay": {
    "Split Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "4 x 1600 Meter Relay": {
    "Split Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "Sprint Medley Relay": {
    "Split Time": Algorithms.averageTime,
    "Distance": Algorithms.minMax,
    "Place": Algorithms.averageToOneDecimal,
  },
  "Distance Medley Relay": {
    "Split Time": Algorithms.averageTime,
    "Distance": Algorithms.minMax,
    "Place": Algorithms.averageToOneDecimal,
  },
  "4 X 110 Meter Hurdles Relay": {
    "Split Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "Shot Put": {
    "Distance": Algorithms.averageFeetAndInches,
    "Place": Algorithms.averageToOneDecimal,
  },
  "Discus Throw": {
    "Distance": Algorithms.averageFeetAndInches,
    "Place": Algorithms.averageToOneDecimal,
  },
  "High Jump": {
    "Distance": Algorithms.averageFeetAndInches,
    "Place": Algorithms.averageToOneDecimal,
  },
  "Pole Vault": {
    "Distance": Algorithms.averageFeetAndInches,
    "Place": Algorithms.averageToOneDecimal,
  },
  "Long Jump": {
    "Distance": Algorithms.averageFeetAndInches,
    "Place": Algorithms.averageToOneDecimal,
  },
  "5000 Meter": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "3000 Meter": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "3000 Meter Steeplechase": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "2000 Meter Steeplechase": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "400 Meter Hurdles": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "Hammer Throw": {
    "Distance": Algorithms.averageFeetAndInches,
    "Place": Algorithms.averageToOneDecimal,
  },
  "Javelin": {
    "Distance": Algorithms.averageFeetAndInches,
    "Place": Algorithms.averageToOneDecimal,
  },
}


statAlgorithmDeclarations["Volleyball"] = {
  "Volleyball": {
    "Sets Played - Matches Played - Matches Started": Algorithms.volleyballPlayedAndStarted,
    "Kills": Algorithms.sum,
    "Kills per Set": Algorithms.killsPerSet,
    "Attack Errors": Algorithms.sum,
    "Attack Total Attempts": Algorithms.sum,
    "Hitting Efficiency": Algorithms.hittingEfficiency,
    "Assists": Algorithms.sum,
    "Assists per Set": Algorithms.assistsPerSet,
    "Assist Total Attempts": Algorithms.sum,
    "Assist Percentage": Algorithms.assistPercentage,
    "Service Aces": Algorithms.sum,
    "Service Aces per Set": Algorithms.acesPerSet,
    "Service Errors": Algorithms.sum,
    "Service Total Attempts": Algorithms.sum,
    "Service Percentage": Algorithms.servicePercentage,
    "Service Receptions": Algorithms.sum,
    "Service Reception Errors": Algorithms.sum,
    "Reception Total Attempts": Algorithms.sum,
    "Reception Percentage": Algorithms.receptionPercentage,
    "Digs": Algorithms.sum,
    "Digs per Set": Algorithms.digsPerSet,
    "Solo Blocks": Algorithms.sum,
    "Block Assists": Algorithms.sum,
    "Total Blocks": Algorithms.sum,
    "Blocks per Set": Algorithms.blocksPerSet,
    "Blocking Errors": Algorithms.sum,
    "Ball Handline Errors": Algorithms.sum,
    "Points": Algorithms.sum,
    "Points per Set": Algorithms.pointsPerSet,
  }
}


statAlgorithmDeclarations["Water Polo"] = {
  "Water Polo": {
    "Goals Scored": Algorithms.sum,
    "Assists": Algorithms.sum,
    "Points": Algorithms.sum,
    "Goals Against Average": Algorithms.averageToTwoDecimals,
    "Saves": Algorithms.sum,
  }
}

statAlgorithmDeclarations["Wrestling"] = {
  "Wrestling": {
    "Weight Class": Algorithms.minMax,
    "Wins": Algorithms.sum,
    "Losses": Algorithms.sum,
    "Major Decisions": Algorithms.sum,
    "Technical Falls": Algorithms.sum,
    "Pins"    : Algorithms.sum,
  }
}


statAlgorithmDeclarations["Field Hockey"] = {
  "Offense": {
    "Points": Algorithms.sum,
    "Goals": Algorithms.sum,
    "Assists": Algorithms.sum,
  },
  "Goalie": {
    "Goals Against Average": Algorithms.averageToTwoDecimals,
    "Shots on Goal": Algorithms.sum,
    "Saves": Algorithms.sum,
    "Win/Loss": Algorithms.ratio,
    "Shutout": Algorithms.sum,
  }
}


statAlgorithmDeclarations["Gymnastics"] = {
  "Floor Exercise": {
    "Points": Algorithms.averageToThreeDecimals,
    "Place": Algorithms.averageToOneDecimal,
  },
  "Uneven Bars": {
    "Points": Algorithms.averageToThreeDecimals,
    "Place": Algorithms.averageToOneDecimal,
  },
  "Balance Beam": {
    "Points": Algorithms.averageToThreeDecimals,
    "Place": Algorithms.averageToOneDecimal,
  },
  "Vault": {
    "Points": Algorithms.averageToThreeDecimals,
    "Place": Algorithms.averageToOneDecimal,
  }
}


statAlgorithmDeclarations["Swimming and Diving"] = {
  "50 Freestyle": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "100 Freestyle": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "200 Freestyle": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "400 Freestyle": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "500 Freestyle": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "50 Butterfly": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "100 Breaststroke": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "100 Backstroke": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "200 Individual Medley": {
    "Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "200 Medley Relay": {
    "Split Time": Algorithms.averageTime,
    "Stroke Swam": Algorithms.strokeSwam,
    "Place": Algorithms.averageToOneDecimal,
  },
  "200 Freestyle Relay": {
    "Split Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "400 Freestyle Relay": {
    "Split Time": Algorithms.averageTime,
    "Place": Algorithms.averageToOneDecimal,
  },
  "1 Meter Dive": {
    "Score": Algorithms.averageToTwoDecimals,
    "Place": Algorithms.averageToOneDecimal,
  },
  "3 Meter Dive": {
    "Score": Algorithms.averageToTwoDecimals,
    "Place": Algorithms.averageToOneDecimal,
  },
  "5 Meter Platform Dive": {
    "Score": Algorithms.averageToTwoDecimals,
    "Place": Algorithms.averageToOneDecimal,
  },
  "7.5 Meter Platform Dive": {
    "Score": Algorithms.averageToTwoDecimals,
    "Place": Algorithms.averageToOneDecimal,
  },
  "10 Meter Platform Dive": {
    "Score": Algorithms.averageToTwoDecimals,
    "Place": Algorithms.averageToOneDecimal,
  },
}


statAlgorithmDeclarations["Tennis"] = {
  "Singles": {
    "Singles Order Position": Algorithms.tennisPositions,
    "Set Score": Algorithms.tennisSetScore,
    "Win": Algorithms.sum,
    "Lose": Algorithms.sum,
  },
  "Doubles": {
    "Doubles Order Position": Algorithms.tennisPositions,
    "Set Score": Algorithms.tennisSetScore,
    "Win": Algorithms.sum,
    "Lose": Algorithms.sum,
  }
}


export default statAlgorithmDeclarations



// WEBPACK FOOTER //
// ./src/utils/StatAlgorithmDeclarations.js